import {
    REDUCER_NAME,
    ROLE_ACCOUNTING,
    ROLE_ADVISING_PHYSICIAN,
    ROLE_CLINIC_MANAGEMENT,
    ROLE_CUSTOMER_SERVICE_TEAM_LEAD,
    ROLE_EMPLOYEE,
    ROLE_EMPLOYEE_CUSTOMER_SERVICE,
    ROLE_EMPLOYEE_DENTAL_TECHNICIAN,
    ROLE_EMPLOYEE_IMPRINT_QA,
    ROLE_EMPLOYEE_SHOP_ASSISTANT,
    ROLE_EMPLOYEE_SHOP_PHYSICIAN,
    ROLE_EMPLOYEE_SHOP_ZFA,
    ROLE_PARTNER,
    ROLE_PARTNER_PHYSICIAN,
    ROLE_PARTNER_SCAN_PHYSICIAN,
    ROLE_PARTNER_TREATMENT_PLANER,
    ROLE_PROCESS_ADMIN,
    ROLE_REPORTING,
    ROLE_RETAIL_QA, ROLE_TREATING_PHYSICIAN, ROLE_TREATING_PHYSICIAN_REMOTE,
    ROLE_TREATMENT_QUOTATION_ADMIN,
} from './const'
import { selectOwnState as selectParentState } from '../selector'

export const selectOwnState = state => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectLoginData = state => {
    return selectOwnState(state).loginData
}

export const selectLoginError = state => {
    return selectOwnState(state).error
}

export const selectUser = state => {
    return selectOwnState(state).user
}

export const selectUserId = state => {
    const user = selectUser(state)
    return user ? user.id : null
}

export const canSeeCustomerNames = state => {
    return selectHasRole(state, [
        ROLE_EMPLOYEE,
        ROLE_PARTNER_PHYSICIAN,
        ROLE_PARTNER_SCAN_PHYSICIAN,
    ])
}

export const selectHasRole = (state, role) => {
    const user = selectUser(state)
    if (!user || !role) {
        return false
    }
    if (!Array.isArray(role)) {
        return user.roleList.indexOf(role) !== -1
    }
    for (let index = 0; index < role.length; index++) {
        if (user.roleList.indexOf(role[index]) !== -1) {
            return true
        }
    }
    return false
}

export const selectIsTQAdmin = state => {
    return selectHasRole(state, ROLE_TREATMENT_QUOTATION_ADMIN)
}

export const selectIsPartner = state => {
    return selectHasRole(state, ROLE_PARTNER)
}

export const selectIsCustomerServiceTeamLead = state => {
    return selectHasRole(state, ROLE_CUSTOMER_SERVICE_TEAM_LEAD)
}

export const selectHasReportingRole = state => {
    return selectHasRole(state, ROLE_REPORTING)
}

export const selectHasProcessAdminRole = state => {
    return selectHasRole(state, ROLE_PROCESS_ADMIN)
}

export const selectCanReassignPhysician = state => {
    return selectHasRole(state, [ROLE_CLINIC_MANAGEMENT, ROLE_RETAIL_QA])
}

export const selectCanReassignStore = state => {
    return selectHasRole(state, [ROLE_CLINIC_MANAGEMENT, ROLE_RETAIL_QA])
}

export const selectHasAccountingRole = state => {
    return selectHasRole(state, ROLE_ACCOUNTING)
}

export const selectIsPasswordResetRequired = state => {
    return selectOwnState(state).passwordResetRequired
}

export const selectCanSeeImages = state => {
    return selectHasRole(state, [
        ROLE_EMPLOYEE_DENTAL_TECHNICIAN,
        ROLE_EMPLOYEE_IMPRINT_QA,
        ROLE_RETAIL_QA,
        ROLE_EMPLOYEE_CUSTOMER_SERVICE,
        ROLE_PARTNER_PHYSICIAN,
        ROLE_PARTNER_PHYSICIAN,
        ROLE_PARTNER_TREATMENT_PLANER,
        ROLE_PARTNER_SCAN_PHYSICIAN,
        ROLE_EMPLOYEE_SHOP_ASSISTANT,
        ROLE_EMPLOYEE_SHOP_PHYSICIAN,
        ROLE_EMPLOYEE_SHOP_ZFA,
        ROLE_ADVISING_PHYSICIAN,
        ROLE_TREATING_PHYSICIAN,
        ROLE_TREATING_PHYSICIAN_REMOTE
    ])
}

export const selectEmployeeRoleList = state => {
    const user = selectUser(state)
    return user.roleList
}

export const selectEmployeeId = state => {
    const user = selectUser(state)
    return user.employeeId
}

export const selectUserStore = state => {
    const { store } = selectUser(state)
    return store
}

export const selectUserVisibleWidgetList = state => {
    const user = selectUser(state)
    return user.visibleWidgetList || [];
}
export const selectUserManuallyVisibleWidgetList = state => {
    const user = selectUser(state)
    return user.visibleWidgetListManuallyAdded || [];
}

export const userHasWidgetInVisibleList = (state, widgetName) => {
    const visibleList = selectUserVisibleWidgetList(state)
    return visibleList.includes(widgetName)
}

export const selectUserRoleList = state => {
    const user = selectUser(state)
    return user.roleList
}

export const userHasAnyOfRoles = (state, roleList) => {
    const userRoleList = selectUserRoleList(state)
    return userRoleList.some(role => roleList.includes(role))
}



// WEBPACK FOOTER //
// ./src/modules/security/state/auth/selector.js